import React from 'react'
import Header from '../components/Header/Header'
import Report from '../components/report/Report'
import DailyReport from '../components/report/DailyReport'

function ReportMain() {
  return (
    <div>
        <Header/>
        <DailyReport/>
    </div>
  )
}

export default ReportMain